import { useNavigate } from 'react-router-dom';
import { useInvoicesTable } from '../../context/TableContext';
import { Button, Container, Devedor } from './styles';
import {
  Devedor as DevedorType,
  useDevedor,
} from '../../context/ConsultContext';

interface PropsCDL {
  page: string;
}

export const CdlMenu = ({ page }: PropsCDL) => {
  const navigate = useNavigate();
  const { setFaturaParcelas, hasFaturaError } = useInvoicesTable();
  const { setDevedor, mostrarData } = useDevedor();

  function devedorButton() {
    setDevedor({} as DevedorType);
    mostrarData(false);
    navigate('/consult');
  }

  function registerButton() {
    setFaturaParcelas([]);
    hasFaturaError(false);
    navigate('/register');
  }

  // function backButton() {
  //   setDevedor({} as DevedorType);
  //   setFaturaParcelas([]);
  //   mostrarData(false);
  //   navigate('/menu');
  // }

  return (
    <Container>
      {/* <CDL>
        <button onClick={backButton}>
          <IoIosArrowRoundBack size={40} color="#707070" />
        </button>
        <img src={cdlImg} alt="CDL Rondonópolis" />
      </CDL> */}

      <Devedor>
        <Button onClick={devedorButton} isActive={page === 'devedor'}>
          Consultar devedor
        </Button>
        <Button onClick={registerButton} isActive={page === 'cadastro'}>
          Iniciar cadastro
        </Button>
      </Devedor>
    </Container>
  );
};
